module.exports = __webpack_public_path__ + "assets/media/guillaume_face.45410bf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/SegmentTestimonial/guillaume_face.jpg
// module id = 2039
// module chunks = 0